import React from "react";
import ReactDOM from "react-dom";
import WebPlayerScrlr from "./WebPlayerScrlr";

let mountNode = null;
let closeScrlrIconPlayer = null;

export function registerScrlrIconPlayerClose(closeFn) {
  closeScrlrIconPlayer = closeFn;
  return () => {
    if (closeScrlrIconPlayer === closeFn) {
      closeScrlrIconPlayer = null;
    }
  };
}

function closeScrlrIconPlayerIfOpen() {
  closeScrlrIconPlayer?.();
}

/**
 * Opens the centered help player on document.body, independent of the caller's
 * React tree. Needed because Profile is hover-mounted and unmounts when the
 * fullscreen scrim steals hover from its parent User.
 */
export function openHelpPlayer(labels) {
  closeScrlrIconPlayerIfOpen();
  closeHelpPlayer();
  mountNode = document.createElement("div");
  document.body.appendChild(mountNode);
  ReactDOM.render(
    <div className="webplayer-scrlr-modal help-center">
      <WebPlayerScrlr onClose={closeHelpPlayer} helpView labels={labels} />
    </div>,
    mountNode
  );
}

export function closeHelpPlayer() {
  if (!mountNode) return;
  try {
    ReactDOM.unmountComponentAtNode(mountNode);
  } catch (_) {}
  if (mountNode.parentNode) mountNode.parentNode.removeChild(mountNode);
  mountNode = null;
}

export default function HelpPlayerModal({ onClose, labels }) {
  // Declarative wrapper kept for callers that outlive hover parents.
  return ReactDOM.createPortal(
    <div className="webplayer-scrlr-modal help-center">
      <WebPlayerScrlr onClose={onClose} helpView labels={labels} />
    </div>,
    document.body
  );
}
